var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClothesWasher({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.25,
    height: 16.25,
    viewBox: "0 0 16.25 16.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Clothes Washer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.13,
    y: 0.13,
    width: 16,
    height: 16,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(1.37 10.94)",
    fontSize: 8.85,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "0.01em",
    style: {
      isolation: "isolate"
    }
  }, "C"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(6.86 10.94)",
    fontSize: 8.85,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    fontFamily: "ArialMT, Arial",
    style: {
      isolation: "isolate"
    }
  }, "W")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClothesWasher);
export default __webpack_public_path__ + "static/media/ClothesWasher.12dd7740d28c528cd6c97d0007c71b36.svg";
export { ForwardRef as ReactComponent };